import { VaultConfig } from 'config/constants/types'
import fetchVault from './fetchVault'

const fetchVaults = async (vaultsToFetch: VaultConfig[]) => {
  const data = await Promise.all(
    vaultsToFetch.map(async (vaultConfig) => {
      const farm = await fetchVault(vaultConfig)
      return farm
    }),
  )
  return data
}

export default fetchVaults
